import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=587047d6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587047d6"]])

export default __exports__